import { render, staticRenderFns } from "./supplierAreaCompare.vue?vue&type=template&id=44adda2b"
import script from "./supplierAreaCompare.vue?vue&type=script&lang=js"
export * from "./supplierAreaCompare.vue?vue&type=script&lang=js"
import style0 from "./supplierAreaCompare.vue?vue&type=style&index=0&id=44adda2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports